import { Chip } from "@mui/material";

import { AndonEventWithMeta } from "./andon.types";
import { mapEventColorAndLetters } from "./andon.utils";

export function EventChip({ event }: { event: AndonEventWithMeta }) {
  const { color, letters } = mapEventColorAndLetters(event);

  return (
    <Chip
      sx={{
        backgroundColor: color
      }}
      size="small"
      label={letters || "✉"}
    />
  );
}
